/* eslint-disable no-use-before-define */
import Divider from '@material-ui/core/Divider';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio, { RadioProps } from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { createStyles, makeStyles, Theme, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React, { FC, useEffect, useState } from 'react';

type Props = {
  name: string;
  radios: RadioValue[];
  onChange: (value: any) => void;
  className?: string;
  withDivider?: boolean;
  index: number;
  defaultPropsValue: string;
};

interface RadioValue {
  label: string;
  value: string;
  disabled?: boolean;
}

const MyRadio = withStyles({
  root: {
    display: 'none',
    '& + span': {
      padding: '5px 10px',
      border: '1px solid #E3E8F0',
      fontFamily: 'ITC Avant Garde Gothic Std Medium',
      letterSpacing: 0,
      borderRadius: 3,
      color: '#2c57a5',
      background: '#fff',
      width: '15px',
      textAlign: 'center'
    },
    '& + span:hover': {
      border: '1px solid #F7DC6F',
    },
    margin: 0,
  },
  checked: {
    '& + span': {
      color: '#fff',
      background: '#F7DC6F',
    },
  },
})((props: RadioProps) => <Radio color="default" {...props} />);

const MyRadio2 = withStyles({
  root: {
    display: 'none',
    '& + span': {
      padding: '5px 10px',
      border: '1px solid #E3E8F0',
      fontFamily: 'ITC Avant Garde Gothic Std Medium',
      letterSpacing: 0,
      borderRadius: 3,
      color: '#2c57a5',
      background: '#ebebeb',
      width: '15px',
      textAlign: 'center'
    },
    '& + span:hover': {
      border: '1px solid #F7DC6F',
    },
    margin: 0,
  },
  checked: {
    '& + span': {
      color: '#fff',
      background: '#F7DC6F',
    },
  },
})((props: RadioProps) => <Radio color="default" {...props} />);
const RadioGrp: FC<Props> = ({
  className = '',
  name,
  radios = [],
  onChange,
  withDivider = false,
  index,
  defaultPropsValue,
}) => {
  const classes = useStyles();
  const [defaultValue, setDefaultValue] = useState('');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDefaultValue((event.target as HTMLInputElement).value);
    const dataValue = {
      value: (event.target as HTMLInputElement).value,
      index,
    };
    onChange(dataValue);
  };
  useEffect(() => {
    setDefaultValue(defaultPropsValue);
  }, [defaultPropsValue]);

  return (
    <RadioGroup
      className={clsx(classes.radioGrp, className)}
      aria-label={name}
      name={name}
      value={defaultValue}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e)}>
      {radios.map((r, i) => (
        <div className={classes.radioItemContainer} key={r.value ?? i}>
          {withDivider && i !== 0 && <Divider orientation="vertical" className={classes.divider} />}
          <FormControlLabel
            key={r.value}
            className={classes.controlLabel}
            value={r.value}
            control={i%2 ? <MyRadio2 /> : <MyRadio />}
            label={r.value}
          />
          <span style={{marginLeft: '5px', fontSize: '14px'}}>{r.label}</span>
        </div>
      ))}
    </RadioGroup>
  );
};

// eslint-disable-next-line no-unused-vars
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    radioGrp: {
      display: 'block !important',
      width: 'fit-content',
      borderRadius: 4,
    },
    controlLabel: {
      margin: '0 !important',
    },
    radioItemContainer: {
      display: 'block',
      marginRight: 20,
    },
    divider: {
      color: 'black',
      '&.MuiDivider-vertical': {
        height: '50%',
      },
    },
  })
);

export default RadioGrp;
